import api from '../../../../api.js';

export const ButtonEmission = {
  CLICK: api.internals.ns.emission('button', 'click')
};
